/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import theme from '~/styles/theme';

import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Question,
  Buttons,
  ButtonContainer,
  ButtonYes,
  ButtonNo,
  ButtonTitle,
  Icon,
} from '../../styles';

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModalCode: false,
    };
  }

  handleResponse = (response) => {
    if (response === 'voltar') {
      return this.props.handleClick('0101020101');
    }
    if (response === 'sim') {
      return this.props.handleClick('01010201010201');
    }
    return this.props.handleClick('01010201010202:3');
  };

  render() {
    const { close } = this.props;
    return (
      <Container>
        <Header className="mb-3">
          <Left>
            <BackButton
              onClick={() => this.handleResponse('voltar')}
              title="Voltar"
              className="mdi mdi-arrow-left"
            />
            <Title>Gostaríamos de entender melhor o problema:</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Buttons>
          <Question>
            Por favor, abra o registro lentamente. Problema Resolvido?
          </Question>
          <ButtonContainer className="mt-5">
            <ButtonNo onClick={() => this.handleResponse('nao')}>
              <AiOutlineCloseCircle color="#ffff" size={30} />
              <ButtonTitle>Não</ButtonTitle>
            </ButtonNo>
            <ButtonYes onClick={() => this.handleResponse('sim')}>
              <AiOutlineCheckCircle
                color={theme.colors.mediumPurple}
                size={30}
              />
              <ButtonTitle>Sim</ButtonTitle>
            </ButtonYes>
          </ButtonContainer>
        </Buttons>
      </Container>
    );
  }
}

export default connect()(Document);
